import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    ARTICLE_SEARCH_FETCH_TRIGGER,
    ArticleSearchFetchNormalizedResponse,
    ArticleSearchFetchTriggerAction,
    articleSearchFetchApi,
} from "@/mk2/apps/wiki/containers/ArticleSearch/ArticleSearch.actions";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { HistoryAction } from "@/mk2/services/browserHistory";
import { wiki_api_v2_search_url } from "@/mk/urls/functions";

const logger = getLogger("wiki/ArticleSearch.sagas");

interface ApiResponseFetchArticle {
    body: {
        entities: ArticleSearchFetchNormalizedResponse["entities"];
        result: ArticleSearchFetchNormalizedResponse["result"];
        hasNext: number;
        hasPrevious: number;
        resultsCount: number;
    };
}

function* articleSearch({
    articleSlug,
    categorySlug,
    query,
    after,
    xhr,
    location,
    routeNavigate,
}: ArticleSearchFetchTriggerAction & XHRAction & HistoryAction) {
    yield put(articleSearchFetchApi.request(articleSlug, categorySlug, query, after));

    try {
        const response: ApiResponseFetchArticle = yield call(() =>
            xhr.get(wiki_api_v2_search_url(), { articleSlug, categorySlug, query, after }),
        );

        yield put(
            articleSearchFetchApi.success(
                articleSlug,
                categorySlug,
                query,
                after,
                response.body.hasNext,
                response.body.hasPrevious,
                response.body.resultsCount,
                {
                    entities: response.body.entities,
                    result: response.body.result,
                },
            ),
        );
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, location, routeNavigate, logger);
        yield put(
            articleSearchFetchApi.failure(
                articleSlug,
                categorySlug,
                query,
                after,
                normalizeError(error),
            ),
        );
    }
}

export default function* root() {
    yield all([takeLatest(ARTICLE_SEARCH_FETCH_TRIGGER, articleSearch)]);
}
